import React from 'react'
import './spinner.css'

function Spinner() {
  return (
    <div className='spinner'>
      <div className='spinner-inner'></div>
    </div>
  )
}

export default Spinner
